module.exports = __webpack_public_path__ + "img/carrot_with_shadow.1dd32ee2.png";